export class VerificationEmailException extends Error {}
export class VerifiedEmailException extends Error {}
export class EmailServiceException extends Error {}
export class UpdateEmailAddressException extends Error {}
export class WarningEmailException extends Error {}
export class ResetPasswordEmailException extends Error {}
